import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store/index';
// 国际化
import VueI18n from 'vue-i18n';
import messages from './assets/i18n/langs'
import MetaInfo from 'vue-meta-info'

// 引入ElementUI
import ElementUI from 'element-ui';
Vue.use(ElementUI);
Vue.use(MetaInfo);
Vue.use(VueI18n);

// ElementUI css
import "element-ui/lib/theme-chalk/index.css";

// 组件挂载到全局
Vue.config.productionTip = false;
// Vue.prototype.$path = process.env.NODE_ENV == "prod" ? "http://araypower.com" : "http://localhost:1024";
Vue.prototype.$path = "http://araypower.com";
Vue.prototype.$origin = window.location.origin;
const i18n = new VueI18n({
    locale: store.state.currentLang, // 语言标识
    fallbackLocale: "zh",
    messages
});

new Vue({
    el: '#app',
    i18n,
    store,
    router,
    render: h => h(App),
    components: {
        App
    },
    template: '<App/>',
    created() { // 全局配置
        router.beforeEach((to, from, next) => {
            if (to.meta.title) {
                document.title = `${ i18n.t(to.meta.title) } | ${ this.$t("langs.sitetitle") }`;
            }
            if (to.meta.content) {
                let head = document.getElementsByTagName('head');
                let meta = document.createElement('meta');
                document.querySelector('meta[name="keywords"]').setAttribute('content', i18n.t(to.meta.content.keywords))
                document.querySelector('meta[name="description"]').setAttribute('content', i18n.t(to.meta.content.description))
                meta.content = to.meta.content;
                head[0].appendChild(meta)
            }
            next();
        })
    }

}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js